module.exports = __webpack_public_path__ + "static/media/relationship-icon.8b947e6e.svg";